export enum FieldName {
  username = "username",
  password = "password",
  email = "email",
  activeFactors = "activeFactors",
}

export const FIELD_ORDER: FieldName[] = [
  FieldName.username,
  FieldName.password,
  FieldName.email,
  FieldName.activeFactors,
];
